/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the QuotaHistoryItem interface.
 */
export function instanceOfQuotaHistoryItem(value) {
    if (!('action' in value) || value['action'] === undefined)
        return false;
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined)
        return false;
    return true;
}
export function QuotaHistoryItemFromJSON(json) {
    return QuotaHistoryItemFromJSONTyped(json, false);
}
export function QuotaHistoryItemFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        ...json,
        'action': json['action'],
        'amount': json['amount'],
        'timestamp': json['timestamp'],
    };
}
export function QuotaHistoryItemToJSON(json) {
    return QuotaHistoryItemToJSONTyped(json, false);
}
export function QuotaHistoryItemToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        ...value,
        'action': value['action'],
        'amount': value['amount'],
        'timestamp': value['timestamp'],
    };
}
